import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const SearchBadgesMaster = withSuspense(lazy(() => import('./badges-master-search')));
export default SearchBadgesMaster;
